import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import StatusChip from "@src/@core/components/ui-components/status-chip";
import { CONTRACT_STATUS_LABEL, CONTRACT_STATUS_TONE } from "@panel/shared/contract/misc/constants";
import {
    KYC_LABEL,
    KYC_TONE,
    FREQUENCY_LABEL,
    PAYMENT_MODEL_LABEL
} from "@src/utility/constants/panel/common";

export const BRANDS_COLUMNS = [
    {
        Header  : "Brand",
        accessor: "name",
        Cell    : ({ value, row }) => (
            <Link to={`/brands/details/${row._id}`} className="group flex items-center gap-3">
                <span className="font-medium text-gray-900 group-hover:text-accent group-hover:underline">{value}</span>
            </Link>
        )
    },
    {
        Header  : "Platform",
        accessor: "platform_name",
        Cell    : ({ value }) => <span className="text-gray-800">{value ? value.charAt(0).toUpperCase() + value.slice(1) : "—"}</span>
    },
    {
        Header  : "Model",
        accessor: "payment_model",
        Cell    : ({ value }) => <span className="text-gray-800">{PAYMENT_MODEL_LABEL[value] || value}</span>
    },
    {
        Header  : "KYC",
        accessor: "kyc_status",
        Cell    : ({ value }) => <StatusChip tone={KYC_TONE[value] || "neutral"} label={KYC_LABEL[value] || value || "—"} />
    },
    {
        Header  : "Contract",
        accessor: "contract_status",
        Cell    : ({ value }) => <StatusChip tone={CONTRACT_STATUS_TONE[value] || "neutral"} label={CONTRACT_STATUS_LABEL[value] || value || "—"} />
    },
    {
        Header  : "Publishers",
        accessor: "affiliate_count",
        Cell    : ({ value }) => <span className="text-gray-800">{value ?? "—"}</span>
    },
    {
        Header  : "Frequency",
        accessor: "debit_note_frequency",
        Cell    : ({ value }) => <span className="text-gray-800">{FREQUENCY_LABEL[value] || value || "-"}</span>
    },
    {
        Header  : "",
        accessor: "_id",
        Cell    : ({ value }) => (
            <div className="flex items-center justify-end">
                <Link to={`/brands/details/${value}`} className="inline-flex items-center gap-1 text-sm font-medium text-accent hover:underline">
                    Open
                    <ArrowRight className="h-3.5 w-3.5" />
                </Link>
            </div>
        )
    }
];
